import React, { useState } from 'react';
import { Modal, Input, message } from 'antd';
import { useAuth } from '../contexts/AuthContext';

const LoginModal = ({ visible, onClose }) => {
  const [apiKey, setApiKeyInput] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleOk = async () => {
    if (!apiKey.trim()) {
      message.error('请输入 API Key');
      return;
    }

    setLoading(true);
    
    // 模拟验证（实际应该调用验证接口）
    setTimeout(() => {
      login(apiKey.trim());
      message.success('登录成功');
      setApiKeyInput('');
      setLoading(false);
      onClose();
    }, 500);
  };

  const handleCancel = () => {
    setApiKeyInput('');
    onClose();
  };

  return (
    <Modal
      title="输入 API Key"
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={loading}
      okText="确认"
      cancelText="取消"
      centered
    >
      <p style={{ marginBottom: 16, color: '#666' }}>
        请输入您的 API Key 以访问博客管理功能
      </p>
      <Input.Password
        placeholder="请输入 API Key..."
        value={apiKey}
        onChange={(e) => setApiKeyInput(e.target.value)}
        size="large"
      />
    </Modal>
  );
};

export default LoginModal;
